import axios from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { cashBookServiceUrl } from '../../../../urls'

const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
}

const cashBookInstance = axios.create({
  baseURL: cashBookServiceUrl,
  headers,
})

cashBookInstance.interceptors.request.use(config => {
  return requestInterceptor(config)
}, error => Promise.reject(error))

cashBookInstance.interceptors.response.use(response => response, error => {
	return responseInterceptor(error)
})

export default cashBookInstance
